import type { ContactImportDialogView } from "./contact-import-dialog-view.js";

export type ImportWizardStep = "file" | "map" | "review";

export const IMPORT_WIZARD_STEPS = ["file", "map", "review"] as const;

/** Setup and mapping stay in the dialog. Progress and summary are after confirm. */
export function activeImportWizardStep(
  dialogView: ContactImportDialogView,
  requested: ImportWizardStep,
): ImportWizardStep | null {
  if (dialogView === "setup") return "file";
  if (dialogView === "map") return requested === "review" ? "review" : "map";
  return null;
}
